import { ColorType, useTheme } from "./AHTheme/AHTheme";
import { IconSize, useLayoutContext } from "./LayoutProvider";

import { BoxProps } from "./AHTheme/BoxProps";
import React from "react";
import { View } from "react-native";

import { useBoxStyle } from "./AHTheme/useBoxStyle";
import { useScaleFactor } from "./AHScaleFactor";
import { RoutineIcon } from "../globalTypes";
import { AHIcon, AHIconType } from "./AHIcon";

function asertNever(_: never) {
  console.warn("No implementation for todo category icon");
}

type RoutineIconProps = {
  type: RoutineIcon | keyof typeof RoutineIcon;
  size?: IconSize;
  color?: ColorType;
  customColor?: string;
} & Omit<BoxProps, "color">;

const routineIconMap: Record<RoutineIcon | string, AHIconType> = {
  [RoutineIcon.shelf_hole]: "albums-outline",
  [RoutineIcon.residual]: "cart-outline",
  [RoutineIcon.waste]: "trash",
  [RoutineIcon.key]: "key-outline",
};

export function AHRoutineIcon(props: RoutineIconProps) {
  const { color: c, size: s, customColor, ...boxProps } = props;
  const boxStyle = useBoxStyle(boxProps);
  const theme = useTheme();
  const layout = useLayoutContext();
  const color = customColor ?? theme[c ?? "darkerText"];
  const sf = useScaleFactor();
  const size = layout.icon[s ?? "small"] * sf;

  const iconType = routineIconMap[props.type];

  if (!iconType) {
    asertNever(props.type as never);
    return null;
  }

  return (
    <View style={boxStyle}>
      <AHIcon type={iconType} customColor={color} forceSize={size} />
    </View>
  );
}
